// extracted by mini-css-extract-plugin
export default {"btn":"chip_btn__XoHMt","click":"chip_click__FQ1RZ","medium":"chip_medium__EJ6qk"};